import { useNavigate } from 'react-router-dom';
import { useCreateChatRoom } from '@pocapan/shared/domains/chat/ui/hooks/useCreateChatRoom';

interface UseCreateDMChatRoomProps {
  userProfileId: string;
}

export const useCreateDMChatRoom = ({ userProfileId }: UseCreateDMChatRoomProps) => {
  const { mutateAsync: createChatRoom } = useCreateChatRoom();
  const navigate = useNavigate();

  const handleCreateDMChatRoom = async (targetUserProfileId: string) => {
    if (!userProfileId || !targetUserProfileId) return;
    try {
      const requestBody = {
        chat_room: {
          source_user_profile_id: userProfileId,
          target_user_profile_id: targetUserProfileId
        }
      };
      const response = await createChatRoom(requestBody);

      if (response?.chatRoomId) {
        navigate(`/chat_rooms/${response.chatRoomId}/v2`);
      } else {
        throw new Error('Failed to create chat room');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return { handleCreateDMChatRoom };
};
